


















import { Component, Prop, Watch, Vue } from "vue-property-decorator";

@Component
export default class PayPalPaymentStatus extends Vue {
  @Prop({ default: "" }) private id!: string;

  closeDialog() {
    this.$store.dispatch("app/closeDialog");
  }
}
